<template>
  <div class="contact-edit app-form-styling flex column width-content align-start gap30">
    <Loader v-if="isLoadingItem"/>
    <template v-else-if="itemToEdit">
      <h2 v-if="itemToEdit._id">{{$t('contactLocales.editContact')}}</h2>
      <h2 v-else>{{$t('contactLocales.createContact')}}</h2>
      <form @submit.prevent="" class="flex column gap20 simple-form">
      <FormInput labelholder="firstName" :required="true" type="text" v-model="itemToEdit.firstName"/>
      <FormInput labelholder="lastName" :required="true" type="text" v-model="itemToEdit.lastName"/>
      <FormInput labelholder="email" :required="true" type="text" v-model="itemToEdit.email"/>
      <!-- <FormInput labelholder="contactLocales.phone" type="phone-number" v-model="itemToEdit.phone"/> -->
      <FormInput labelholder="contactLocales.mobile" type="phone-number" v-model="itemToEdit.mobileData" @change="val => itemToEdit.mobile = val.formatted"/>
      <FormInput labelholder="contactLocales.role" type="text" v-model="itemToEdit.role"/>
      <!-- <FormInput type="text" v-model="itemToEdit.name"/> -->
      <TagPicker     :organizationId="orgId" :showLabel="true" v-model="itemToEdit.tags"    :allowAddValsToMultiSelect="true"/>
      <CompanyPicker :organizationId="orgId" :showLabel="true" v-model="itemToEdit.company" :allowAddValsToMultiSelect="true"/>
      <!-- <FormInput labelholder="contactLocales.cellular" type="text" v-model="itemToEdit.cellular"/> -->
      <FormInput labelholder="contactLocales.notes" type="textarea" v-model="itemToEdit.note"/>
      <div class="flex column gap20">
        <p>{{$t('settingsLocales.settings')}}:</p>
        <FormInput labelholder="contactLocales.maxTimesAllowdToWatchVideo" type="number" :min="0" v-model="itemToEdit.settings.maxTimesAllowdToWatchVideo"/>
      </div>
    </form>
    <div v-if="itemToEdit._id">
      <button @click="toggleSubscribtionValue" class="btn big">
        <p v-if="unsubscribed">{{$t('contactLocales.reSubscribe')}}</p>
        <p v-else>{{$t('contactLocales.unsubscribe')}}</p>
      </button>
    </div>
    <div class="flex width-all align-center space-between gap30">
      <div class="align-center flex gap30">
        <button class="btn big" @click="close">{{$t('cancel')}}</button>
        <button class="btn big primary" :disabled="!isItemValid" @click="saveItem">{{$t('save')}}</button>
      </div>
      <button class="btn big danger clear" v-if="itemToEdit._id" @click="deleteItem">{{$t('delete')}}</button>
    </div>
    <Loader v-if="isLoading"/>
    </template>
  </div>

</template>

<script>
import FormInput from '@/apps/common/modules/common/cmps/FormInput.vue';
import CompanyPicker from '../../company/cmps/CompanyPicker.vue';
import TagPicker from '../../tag/cmps/TagPicker.vue';
import { distributionService } from '../../release/services/distribution.service';
import { alertService } from '@/apps/common/modules/common/services/alert.service';
import Loader from '@/apps/common/modules/common/cmps/Loader.vue';
export default {
  name: 'ContactEdit',
  data() {
    return {
      itemToEdit: null,
      unsubscribed: false,
      isLoadingItem: false
    }
  },
  computed: {
    isItemValid() {
      return this.itemToEdit && this.itemToEdit.email && this.itemToEdit.firstName && this.itemToEdit.lastName;
    },
    orgId() {
      return this.$route.params.organizationId;
    },
    isLoading() {
      return this.$store.getters['contact/isLoading'];
    }
  },
  methods: {
    async getItem() {
      // If no ID, it's "Add Contact" - initialize empty
      if (!this.$route.params.id) {
        this.itemToEdit = {
          organizationId: this.orgId,
          settings: { maxTimesAllowdToWatchVideo: 10 }
        }
        return
      }
      
      // Load existing contact
      this.isLoadingItem = true
      this.itemToEdit = await this.$store.dispatch({ type: 'contact/loadItem', id: this.$route.params.id, organizationId: this.orgId });
      this.itemToEdit.organizationId = this.orgId;
      this.unsubscribed = this.itemToEdit.unsubscribed || false;
      delete this.itemToEdit.unsubscribed;
      if (!this.itemToEdit.settings) this.itemToEdit.settings = { maxTimesAllowdToWatchVideo: 10 }
      this.isLoadingItem = false
    },
    async saveItem() {
      if (!this.isItemValid) return;
      await this.$store.dispatch({ type: 'contact/saveItem', item: this.itemToEdit, organizationId: this.orgId });
      this.close();
    },

    async deleteItem() {
      await this.$store.dispatch({ type: 'contact/removeItem', id: this.$route.params.id, organizationId: this.orgId });
      this.close();
    },
    close() {
      this.$router.push({ name: 'ContactPage', params: { organizationId: this.orgId } })
    },
    async toggleSubscribtionValue() {
      if (!await alertService.Confirm(this.$t('contactLocales.confirmToggleSubscriptionValueMsg'))) return;
      this.$store.commit({ type: 'contact/setLoading', val: true });
      const newVal = await distributionService.updateSubscriptionValue(this.itemToEdit._id, this.orgId, !this.unsubscribed);
      this.unsubscribed = newVal.value;
      this.$store.commit({ type: 'contact/setLoading', val: false });
    }
  },
  created() {
    this.getItem()
  },
  watch: {
    '$route.params.id'() {
      this.getItem();
    }
  },
  components: {
    FormInput,
    CompanyPicker,
    TagPicker,
    Loader
  }
}
</script>

<style lang="scss">
@import '@/assets/styles/global/index';
.megaphon-app {
  .contact-edit {
    max-width: 600px;
    min-width: 500px;
    max-height: 80vh;
    overflow-y: auto;
    padding: em(30px);
    // .input {
    //   max-width: 500px;
    // }
    .simple-form {
      width: 100%;
    }

    @media (max-width: $small-screen-break) {
      min-width: unset;
      max-width: 95vw;
      padding: em(20px);
    }
  //   .input {
  //     flex: 1;
  //   }
  //   .label {
  //     width: em(100px);
  //   }
  }
}
</style>